import { LoaderCircle } from 'lucide-react';

function Loading({ color, background }) {
  return (
    <div
      className={`fixed inset-0 h-full w-full ${background || 'bg-white'} flex flex-col items-center justify-center space-y-4 text-2xl`}
    >
      <LoaderCircle className={`mx-auto animate-spin ${color || 'text-black'}`} size={60} />
    </div>
  );
}

export default Loading;
